module.exports = __webpack_public_path__ + "static/media/YF11_2.08020c51.jpg";